/**
 * Cart Toggle Upsell Sync
 * ------------------------
 * Fixes an issue where a preselected cart-drawer upsell/gift toggle
 * (e.g. "Shipping protection") shows as selected in the drawer UI but
 * never actually gets added to the real Shopify cart, because the
 * theme's own init routine only runs once when the page first loads
 * (while the cart is still empty).
 *
 * This listens for the theme's internal "cartUpdate" event (fired on
 * every add/remove/quantity change) and re-syncs every toggle so that:
 *  - a selected toggle that isn't in the cart gets added
 *  - a deselected toggle that is in the cart gets removed
 * Relies on the theme's existing `subscribe`, `PUB_SUB_EVENTS`, and the
 * `addRemoveFromCart()` method already defined on <cart-drawer-upsell>
 * and <cart-drawer-gift> elements in main.js - no new cart logic added.
 */
(function () {
  function syncCartToggleUpsells() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    cartDrawer
      .querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift')
      .forEach(function (el) {
        if (typeof el.addRemoveFromCart === 'function') {
          el.addRemoveFromCart();
        }
      });
  }

  function subscribeWhenReady(retries) {
    retries = retries || 0;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        // small delay so the freshly-rendered cart-drawer markup has
        // connected (custom elements need to finish upgrading first)
        setTimeout(syncCartToggleUpsells, 50);
      });
    } else if (retries < 50) {
      setTimeout(function () {
        subscribeWhenReady(retries + 1);
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      subscribeWhenReady();
    });
  } else {
    subscribeWhenReady();
  }
})();
